import { render, staticRenderFns } from "./CharacterSelect.vue?vue&type=template&id=c4d42e8c&scoped=true&"
import script from "./CharacterSelect.vue?vue&type=script&lang=js&"
export * from "./CharacterSelect.vue?vue&type=script&lang=js&"
import style0 from "./CharacterSelect.vue?vue&type=style&index=0&id=c4d42e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d42e8c",
  null
  
)

export default component.exports